<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2298_8157)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.0688 16.8816L23.1639 19.8284C23.2072 19.8893 23.2345 19.9543 23.2478 20.02L24.2907 20.0277H24.2907C25.163 20.0341 25.5991 20.0372 25.7425 19.7609C25.886 19.4845 25.6323 19.1297 25.125 18.4201L23.3368 15.9188C22.94 15.3638 22.7417 15.0863 22.4716 15.0936C22.2015 15.101 22.0185 15.3888 21.6523 15.9643L21.0688 16.8816Z" fill="currentColor"/>
<path d="M12.9549 20.3388C11.8787 20.3308 11.3405 20.3267 11.1354 20.012C10.9302 19.6972 11.192 19.2772 11.7155 18.4372L14.9689 13.2165C15.4946 12.3729 15.7575 11.9511 16.1661 11.9418C16.5747 11.9325 16.8613 12.3417 17.4345 13.1602L21.1273 18.4329C21.7388 19.306 22.0446 19.7426 21.8376 20.0731C21.6306 20.4036 21.0541 20.3993 19.9011 20.3907L12.9549 20.3388Z" fill="currentColor"/>
<circle cx="21.1507" cy="11.3243" r="1.44465" fill="currentColor"/>
<rect x="4.7" y="3.7" width="28.6" height="22.6" rx="1.8" stroke="currentColor" stroke-width="1.4"/>
</g>
<defs>
<clipPath id="clip0_2298_8157">
<rect width="38" height="30" fill="white"/>
</clipPath>
</defs>
</svg>
